module.exports = __webpack_public_path__ + "static/media/excel.b6817f67.svg";